import { PersonCard } from "@jesus-central-church/ui";
import { SbBlokData, storyblokEditable } from "@storyblok/react/rsc";
import { SbPersonCard } from "@storyblok/types/287435740670216/storyblok-components";

export function PersonCardComponent({ blok }: { blok: SbPersonCard }) {
  return (
    <PersonCard
      name={blok.name}
      role={blok.role}
      image={
        blok.image?.filename
          ? { src: blok.image.filename, alt: blok.image.alt || blok.name }
          : undefined
      }
      quote={blok.quote}
      roleColor={blok.roleColor as "gold" | "green" | "red"}
      variant={blok.variant as "featured" | "standard" | "compact"}
      {...storyblokEditable(blok as SbBlokData)}
    />
  );
}
